import { render, staticRenderFns } from "./BindEmail.vue?vue&type=template&id=b2068aec&scoped=true&lang=pug&"
import script from "./BindEmail.vue?vue&type=script&lang=js&"
export * from "./BindEmail.vue?vue&type=script&lang=js&"
import style0 from "./BindEmail.vue?vue&type=style&index=0&id=b2068aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2068aec",
  null
  
)

export default component.exports